import React from "react";
import TitleTextLayout from "../components/Base/TitleTextLayout";
import { Box, Container, Grid, useMediaQuery } from "@mui/material";
import { VERTICAL_SPACE, baseGrey } from "../graphic/theme";
import kontejnerImg from "../graphic/Images/kontejner.png";
import kontejnerImgwebp from "../graphic/Images/kontejner.webp";
import { theme } from "../../App";
import ArticleText from "../components/Base/ArticleText";
import { useNavigate } from "react-router-dom";

export default function KontejneryLayout() {
  let _900to1050 = useMediaQuery(theme.breakpoints.between("900", "1050"));
  let navigate = useNavigate();

  return (
    <div style={{}}>
      <Container
        maxWidth="lg"
        sx={{
          //bgcolor: baseGrey,
          pl: "0px !important",
          position: "relative",
          overflowX: "hidden",
          overflowY: "hidden",
          height: { xs: "auto", sm: "920px", md: "620px" },
          maxHeight: { xs: "auto", sm: "920px", md: "620px" },
        }}
      >
        <Grid
          container
          spacing={2}
          columns={24}
          sx={{
            px: VERTICAL_SPACE,
            pt: "0px",
            pb: "0px",
          }}
        >
          <Grid
            item
            xs={24}
            sm={24}
            md={24}
            lg={24}
            sx={{
              zIndex: "90",
              display: "flex",
              justifyContent: {
                xs: "flex-start",
                sm: "flex-start",
                md: "flex-end",
              },
            }}
          >
            <ArticleText
              sxProps={{ pt: "40px", maxWidth: { sm: "500px", md: "340px" } }}
              sxTitle={{ maxWidth: { sm: "340px", md: "340px" } }}
              sxText={{ maxWidth: { sm: "500px", md: "340px" } }}
              blueText="Kontejnery"
              title="Stavební kontejnery mnoha rozměrů"
              text="Přistavíme vám stavební kontejnery na stavební suť i vysokoobjemový odpad. K dispozici máme kontejnery mnoha rozměrů."
              buttonText={"Zjistit víc"}
              onButtonClick={() => {
                navigate("/kontejnery");
              }}
            />
          </Grid>
          <Box
            sx={{
              position: { xs: "relative", sm: "absolute" },
              left: {
                xs: "auto",
                sm: 0,
                md: _900to1050 ? -230 : -100,
                lg: 0,
              },
              top: { xs: "auto", sm: 350, md: 0 },
              mt: "40px",
              minHeight: { xs: "340px", sm: "auto" },
            }}
          >
            <picture>
              <source srcSet={kontejnerImgwebp} type="image/webp" />
              <Box
                component="img"
                alt="Uvod"
                src={kontejnerImg}
                sx={{ height: { xs: "280px", sm: "500px" }, width: "auto" }}
              />
            </picture>
          </Box>
        </Grid>
      </Container>
    </div>
  );
}
